export function getTextFromHTML(html: string | undefined) {
  if (!html) {
    return "";
  }

  const div = document.createElement("div");
  div.innerHTML = html;
  return div.textContent?.trim() ?? "";
}
